import { apiUrl, authHeaders } from '@/lib/shell';

export async function actionRequest<T>(
  id: string,
  suffix = '',
  method = 'GET',
  body?: unknown,
): Promise<T> {
  const response = await fetch(apiUrl(`/api/v1/actions/${encodeURIComponent(id)}${suffix}`), {
    method,
    credentials: 'same-origin',
    headers: {
      ...authHeaders(),
      ...(body === undefined ? {} : { 'Content-Type': 'application/json' }),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(
      typeof payload.error === 'string' ? payload.error : 'action_request_failed',
    ) as Error & { status?: number };
    error.status = response.status;
    throw error;
  }
  return payload as T;
}
